module.exports = __webpack_public_path__ + "img/7279834.jpg";